import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-yearselect',
  templateUrl: './yearselect.component.html',
  styleUrls: ['./yearselect.component.scss']
})
export class YearselectComponent implements OnInit {
  @Input()  model!: string;
  @Input()  from?: number;
  @Input()  to?: number ;
  @Output() modelChange = new EventEmitter<string>();

  years = new Array<string>();

  constructor() {  }

  ngOnInit(): void {
    if (this.from == null){
      this.from = 1900;
    }
    if (this.to == null){
      this.to = (new Date()).getFullYear();
    }
    for (let index = this.from; index <= this.to; index++) {
      this.years.push(String(index));
    }
  }

  // tslint:disable-next-line: typedef
  eventChange(){
    this.modelChange.emit(this.model);
  }

}

